import { guid } from '../util/helpers'

const fields = {
  basic: []
}

function seed () {
  const basic = [
    { name: 'Prénom & Nom', type: 'text', value: '' },
    { name: 'Fonction', type: 'text', value: '' },
    { name: 'Organisation', type: 'text', value: '' },
    { name: 'Site internet', type: 'link', value: '' },
    { name: 'Email', type: 'email', value: '' },
    { name: 'Téléphone', type: 'text', value: '' }
  ]

  basic.forEach(item => {
    fields.basic.push({ ...item, id: guid() })
  })

  addPlaceholder()
}

function addPlaceholder () {
  const placeholders = [
    'John Doe',
    'Frontend developer',
    'JohnDoe LLC',
    'johndoe.com',
    'mail@jonhdoe.com',
    '+ 1 123 456 7890'
  ]

  fields.basicPlaceholder = [
    ...fields.basic.map((item, index) => {
      return { ...item, value: placeholders[index] }
    })
  ]
}

seed()

export default fields
